import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['accordionContainer', 'accordion', 'show', 'hide']

  className () {
    return this.element.dataset.classname
  }

  connect () {
    if (this.hasAccordionTarget) {
      if (this.accordionTarget.clientHeight > this.accordionTarget.dataset.height) {
        this.showTarget.style.display = 'flex'
        this.accordionTarget.classList.add(`${this.className()}::hidden`)
      } else {
        this.showTarget.style.display = 'none'
        this.accordionTarget.classList.remove(`${this.className()}::hidden`)
      }
    }
  }

  show (e) {
    this.accordionTarget.classList.remove(`${this.className()}::hidden`)
    e.target.style.display = 'none'
  }
}
